import * as React from 'react';
import { useContext } from 'react';
import { UserContext } from '../../contexts/context-layout-user';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import Slide from '@mui/material/Slide';
import LinearProgress from '@mui/material/LinearProgress';
import { useTranslation } from "react-i18next";
import { editCases, getCasesMenu, getLimitsMenu } from '../../actions/cases';
import TableCases from './table-cases';
import { casesConsult } from '../../actions/cases';
import { errors } from '../../config/errors';
import ModalDialogComponent from '../../components/dialog/dialog-component';
import { Box, Modal, Typography } from '@mui/material';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function ModalCases(props) {
  const {
    startComparison, setSecondCases, //setComparations,
    setCopyFilteredCasesMenu,
    setStartComparison, setLayers,
    layers, setIndexCaseOne,
    setIndexCaseTwo, setFilteredCasesMenu,
    setCopyFilteredCases, setPinState,
    setListState, filteredCases,
    setCases, cases,
    setCounterCase, setCasesToCompare,
    loader, setLoader,
    deleteMultipleCases, setDeleteMultipleCases,
    getMenuCases,UpdateMenuCases,
    filteredCasesMenu, caseSelect, element, setElement, setGeneratorData
  } = useContext(UserContext);

  const [open, setOpen] = React.useState(false);
  const [activeList, setActiveList] = React.useState([])
  const [modalMessages, setModalMessages] = React.useState(false);
  const [openErrorModal, setOpenErrorModal] = React.useState(false);

  const handleClickOpen = async () => {

    setActiveList(filteredCases)
    try {
      setLoader(false);
      setOpen(true);
      if (cases.length === 0) {
        setLoader(true);
        casesConsult().then((info) => {
          if (info.status === 200) {
            setLoader(false);
            setCases(info.response);
          }
        })


      }

    } catch (error) {
      errors.addErroLog(
        {
          data: {
            url: window.location,
            error: error.toString(),
            message: error.message,
            file: error.file,
            line: error.line
          }
        }).then();
      console.log(error)
    }

  };

  const handleClose = (action) => {

    let filterCasesMenu = filteredCases.map(row => row._id)

    if (activeList.length >= 0 && action === "close") {
      setOpen(false)
      setDeleteMultipleCases([]);
    } else {
      setLoader(true)
      if (props.functionality === 1) {

        getLimitsMenu({ cases: filterCasesMenu }).then(response => {
          const filteredCasesCopy = response.response.cases
          const elementCopy = response.response.elementData
          setFilteredCasesMenu(filteredCasesCopy);
          setCopyFilteredCasesMenu(filteredCasesCopy);
          setElement(elementCopy)
          setPinState(new Array(filteredCases.length).fill(false));
          const temporal = {}
          filteredCases.map(row => temporal[row._id] = false)
          setListState(temporal);
          setCounterCase([]);
          setCasesToCompare([]);
          setOpen(false);
          setIndexCaseOne({})
          setIndexCaseTwo({})
          startComparison && setStartComparison(!startComparison);
          setLayers(response.response.cases)
          setGeneratorData(response.response.cases)
          setSecondCases([])
        })

      } else {

        getCasesMenu({ cases: filterCasesMenu }).then(response => {
          const filteredCasesCopy = response.response.cases
          setFilteredCasesMenu(filteredCasesCopy);
          setCopyFilteredCasesMenu(filteredCasesCopy);
          setPinState(new Array(filteredCases.length).fill(false));
          const temporal = {}
          filteredCases.map(row => temporal[row._id] = false)
          setListState(temporal);
          setCounterCase([]);
          setCasesToCompare([]);
          setOpen(false);
          setIndexCaseOne({})
          setIndexCaseTwo({})
          startComparison && setStartComparison(!startComparison);
          setLayers({})
          setSecondCases([])
        })

      }

    }
  };

  const handleDelete = async () => {
    setModalMessages(false);
    const jsonCase = { active: false };
    editCases({ cases: deleteMultipleCases, jsonCase })
      .then((response) => {
        if (response.status === 200) {
          const temporal = filteredCasesMenu.filter(ele => !deleteMultipleCases.includes(ele._id));
          setFilteredCasesMenu(temporal);
          setCases(cases.filter(ele => !deleteMultipleCases.includes(ele._id)));
          setModalMessages(false);
          if (Array.isArray(layers) && layers.some(layer => deleteMultipleCases.includes(layer._id))) {
            setLayers(layers.filter(layer => !deleteMultipleCases.includes(layer._id)));
          }
          setDeleteMultipleCases([]);
        } else {
          setOpenErrorModal(true);
        }
      })
      .catch(error => {
        errors.addErroLog({
          data: {
            url: window.location,
            error: error.toString(),
            message: error.message,
            file: error.file,
            line: error.line
          }
        });
        console.error(error);
      });
  }

  const [t, i18next] = useTranslation("global")

  return (
    <>

      <div style={{ display: "inline-block" }}>

        <IconButton aria-label="fingerprint" color="primary" onClick={handleClickOpen} >
          <LibraryBooksIcon style={{ color: '#939494' }} />
        </IconButton>

        <BootstrapDialog onClose={() => { handleClose("close") }} aria-labelledby="customized-dialog-title" open={open} TransitionComponent={Transition} fullWidth={true} maxWidth='md'>
          <BootstrapDialogTitle id="customized-dialog-title" onClose={() => { handleClose("close") }}>
            {t("board.casesHistory.casesHistory")}
          </BootstrapDialogTitle>
          <DialogContent dividers sx={{ overflow: 'hidden' }}>
            {loader ? <LinearProgress /> : <TableCases />}

          </DialogContent>
          <DialogActions
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              px: 2
            }}
          >
            <Button
              disabled={deleteMultipleCases.length === 0}
              autoFocus
              style={{ color: "#7220db", fontWeight: "bold" }}
              onClick={() => { setModalMessages(true) }}
            >
              {t("board.deleteCase.deleteCases")}
            </Button>
            <Button
              autoFocus
              style={{ color: "#7220db", fontWeight: "bold" }}
              onClick={() => { handleClose("") }}
            >
              {t("board.casesHistory.popUpUpload")}
            </Button>
          </DialogActions>

        </BootstrapDialog>
      </div>
      <ModalDialogComponent
        view={modalMessages}
        tittle={t("board.deleteCase.confirm")}
        message={t("board.deleteCase.deleteMultipleDescription")}
        buttons={[
          {
            value: t("board.deleteCase.cancel"),
            onclick: () => setModalMessages(false),
          },
          {
            value: t("board.deleteCase.accept"),
            color: "transparent",
            colorText: "#7220db",
            onclick: handleDelete
          }
        ]}
      />
       <Modal
        open={openErrorModal}
        onClose={() => setOpenErrorModal(false)}
        disableAutoFocus
       >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "60%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "white",
            boxShadow: 24,
            padding: 4,
            borderRadius: "10px",
          }}
        >
          <Typography variant="h6" gutterBottom>
            {t('board.deleteCase.errorUpdateCases')}
          </Typography>
          <Button
            variant="contained"
            style={{ backgroundColor: "#7220db", color: "white" }}
            onClick={() => setOpenErrorModal(false)}
            sx={{ marginTop: 2 }}>
            {t('board.deleteCase.accept')}
          </Button>
        </Box>
      </Modal>
    </>
  );

}